import styles from './IngenierieAgroecologique.module.css'

import { LogoMetropoleBasic, LogoVilleBasic } from '../../../svg/SvgComponents'
import LogoPATMinistere from '../../../../assets/images/Logo_PAT_ministère.jpg'

const IngenierieAgroecologique = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo}>
        <img src={LogoPATMinistere} alt="Logo PAT Ministère" />
      </div>
      <div className={styles.logo}>
        <LogoMetropoleBasic />
      </div>
      <div className={styles.logo}>
        <LogoVilleBasic />
      </div>
    </header>
  </>
)

export default IngenierieAgroecologique
